import * as z from "zod";

export const getRedoLandmarkGlobalIntegration = {
  name: "getRedoLandmarkGlobalIntegration" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({ exists: z.boolean() }),
};
